import PropTypes from 'prop-types';
import sx from '@styled-system/css';
import styled from '@emotion/styled';
import shouldForwardProp from '@styled-system/should-forward-prop';
import variant from '@styled-system/variant';

const Base = styled('div', { shouldForwardProp })(
  ({ disabled = false }) =>
    sx({
      alignSelf: 'center',
      fontWeight: 400,
      borderRadius: 1,
      textAlign: 'center',
      textTransform: 'uppercase',
      textDecoration: 'none',
      cursor: 'pointer',
      lineHeight: 'root',
      userSelect: 'none',
      transition:
        'color .1s linear, box-shadow .1s linear, background-color .1s linear',
      '&:[disabled]': {
        cursor: 'not-allowed',
      },
      ...(disabled && {
        cursor: 'not-allowed',
      }),
    }),
  variant({
    prop: 'size',
    variants: {
      lg: {
        fontSize: 'root',
        py: 6,
        px: 8,
      },
      md: {
        fontSize: -1,
        py: 4,
        px: 6,
      },
      sm: {
        fontSize: -1,
        py: 3,
        px: 4,
        lineHeight: 1,
      },
      xs: {
        py: 2,
        px: 4,
        fontSize: -2,
        textTransform: 'capitalize',
      },
    },
  }),
);

Base.propTypes = {
  /** content to be rendered inside of the button. Could be text or text paired
   * with an icon.
   */
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOfType([
    PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
    PropTypes.arrayOf(PropTypes.oneOf(['sm', 'md'])),
  ]),
  /** apply this prop if the button isn't interactible */
  disabled: PropTypes.bool,
};

Base.defaultProps = {
  size: 'md',
  disabled: false,
};

Base.displayName = 'Monterey(Button.Base)';

export default Base;
